"use strict";

exports.__esModule = true;
var _Header = require("./Header");
Object.keys(_Header).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Header[key]) return;
  exports[key] = _Header[key];
});